<template>
    <div class="lam-linear-calendar-container">
        <div
            class="chart-row chart-lines"
            :style="{ 'grid-template-columns': `${row_header_width}px repeat(${weeks.length}, ${cell_width}px)` }"
        >
            <span
                v-for="week in weeks"
                :key="week.valueOf()"
            ></span>
        </div>
        <div class="lam-linear-calendar">
            <div class="chart">
                <div
                    class="chart-row chart-period uk-text-small"
                    :style="{ 'grid-template-columns': `${row_header_width}px repeat(${weeks.length}, ${cell_width}px)` }"
                >
                    <div class="chart-row-item"></div>
                    <span
                        v-for="(week, index) in weeks"
                        :key="week.valueOf()"
                    >
                        <span v-if="week.isoWeek() === 1">
                            {{ week.format("YYYY") }}
                        </span>
                        <span
                            v-else-if="!index || !(index % 4) || (index >= (weeks.length - 1))"
                        >
                            {{ week.format("MMM DD") }}
                        </span>
                    </span>
                </div>
            </div>
            <div
                v-for="project in sorted_projects"
                :key="project.id"
                class="chart-row"
                @click.prevent="route_to_record(project.id, $event)"
            >
                <div
                    :class="{ [project.significance]: false }"
                    class="chart-row-item"
                >
                    <div>
                        <router-link
                            :to="{ name: 'project.edit', params: { id: project.id } }"
                        >
                            {{ project.number }} {{ project.name }}
                        </router-link>
                        <!--
                        <div class="uk-text-small">
                            <favorite-input
                                v-if="editable"
                                name="favorite"
                                v-model="project.favorite"
                                class="uk-margin-small-right"
                                @input="save_favorite(project, ...$event)"
                            />
                            Remaining: ${{ project.computed_fee - project.computed_spent | nibnut.number("0,0") }} &bull; {{ role_for_project(project) }}
                        </div>
                        //-->
                    </div>
                </div>
                <ul
                    :class="{ [project.significance]: true }"
                    class="chart-row-bars"
                    :style="{ 'grid-template-columns': `repeat(${weeks.length}, ${cell_width}px)` }"
                >
                    <li
                        v-for="phase in sorted_project_phases(project)"
                        :key="phase.id"
                        :style="{ 'grid-column': phase_grid_column(phase) }"
                    >
                        <div
                            class="phase"
                            :style="{ 'background-color': phase.hex_color, 'color': (is_dark_color(phase.hex_color) ? 'white' : false), 'border-color': phase.hex_color }"
                        >
                            <div
                                v-for="milestone in phase_milestones(phase)"
                                :key="milestone.id"
                                data-uk-tooltip="{pos:'bottom'}"
                                :title="milestone_tooltip(milestone)"
                                :class="{ task: !!milestone.milestone_title }"
                                class="milestone"
                                :style="{ left: `${phase_milestone_position(phase, milestone)}px`, width: `${cell_width}px` }"
                            >

                            </div>
                            <span
                                data-uk-tooltip="{pos:'bottom'}"
                                :title="phase_tooltip(phase)"
                            >
                                <span class="chip"></span>{{ phase.title || phase.abbreviation }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import is_remote_data_table_source from "../mixins/IsRemoteDataTableSource"
import project_utilities from "../mixins/ProjectUtilities"
import ui_utilities from "../mixins/UiUtilities"
import handles_saving from "../mixins/HandlesSaving"

export default {
    mixins: [is_remote_data_table_source, project_utilities, ui_utilities, handles_saving],
    watch: {
        userId: "context_changed",
        currentStatusFilter: "context_changed",
        currentSort: "context_changed",
        currentSortDir: "context_changed",
        dateRange: "context_changed"
    },
    mounted () {
        this.mounted = true
        this.context_changed()
    },
    methods: {
        context_changed () {
            this.set_state_values({
                page: 1,
                context_id: this.userId,
                filter: this.currentStatusFilter,
                sort_by: this.currentSort,
                sort_dir: this.currentSortDir,
                scope: this.dateRange
            })
            console.log("context_changed", this.state)
            this.refresh()
        },
        refresh () {
            if(!this.entity) console.error("IsRemoteDataTableSource has no entity defined.")
            if((this.state.context_id >= 0) && this.profile_id) {
            // if(this.profile_id) {
                console.log("refresh", this.state)
                const query = {
                    ...this.state,
                    fields: this.fields,
                    relation_ids: this.relation_ids
                }

                this.loading = true
                this.$store.dispatch(
                    "FETCH_RECORDS",
                    {
                        entity: this.entity,
                        query
                    }
                ).then(response => {
                    this.current_records_ids = response.record_ids

                    this.set_state_values({
                        total: response.total || 0,
                        found: response.found || 0,
                        query_info: response.query_info || {}
                    })

                    this.post_load(response)
                }).catch(error => {
                    this.$error(error.message)
                }).then(() => {
                    this.loading = false
                })
            }
        },
        sorted_project_phases (project) {
            const range_start = this.$moment().startOf("isoWeek")
            const range_end = this.$moment().startOf("isoWeek").add(this.state.scope, "weeks")
            return orderBy(this.raw_phase_records.filter(phase => {
                return (phase.project_id === project.id) &&
                    (
                        (
                            !!phase.computed_starts_at_as_string &&
                            this.$moment(phase.computed_starts_at_as_string).isSameOrBefore(range_end)
                        ) && (
                            !!phase.computed_ends_at_as_string &&
                            this.$moment(phase.computed_ends_at_as_string).isSameOrAfter(range_start)
                        )
                    )
                /*
                return (phase.project_id === project.id) &&
                    (
                        (
                            !!phase.computed_starts_at_as_string &&
                            this.$moment(phase.computed_starts_at_as_string).isBetween(range_start, range_end, undefined, "[]")
                        ) || (
                            !!phase.computed_ends_at_as_string &&
                            this.$moment(phase.computed_ends_at_as_string).isBetween(range_start, range_end, undefined, "[]")
                        )
                    )
                */
            }), "computed_starts_at_as_string", "asc")
        },
        phase_start_date (phase) {
            const min_date = this.min_date
            return this.$moment.max(this.$moment(phase.computed_starts_at_as_string), min_date)
        },
        phase_grid_column (phase) {
            const min_date = this.min_date
            const first_week = this.phase_start_date(phase).startOf("isoWeek")
            let week_index = Math.round(first_week.diff(min_date, "weeks")) + 1
            if(week_index <= 0) week_index = 1
            const number_of_weeks = Math.round(this.$moment(phase.computed_ends_at_as_string).startOf("isoWeek").diff(first_week, "weeks")) + 1
            return `${week_index}/${week_index + number_of_weeks}`
        },
        phase_milestones (phase) {
            const range_start = this.$moment().startOf("isoWeek")
            const range_end = this.$moment().startOf("isoWeek").add(this.state.scope, "weeks")
            return orderBy(this.raw_task_records.filter(task => {
                return !task.milestone_id && (task.phase_id === phase.id) &&
                    (
                        (
                            !!task.starts_at_as_string &&
                            this.$moment(task.starts_at_as_string).isSameOrBefore(range_end)
                        ) && (
                            !!task.ends_at_as_string &&
                            this.$moment(task.ends_at_as_string).isSameOrAfter(range_start)
                        )
                    )
            }), "starts_at_as_string", "asc")
        },
        phase_milestone_position (phase, milestone) {
            const week_index = this.$moment(milestone.ends_at_as_string).startOf("isoWeek").diff(this.phase_start_date(phase), "weeks")
            return week_index * this.cell_width
        },
        phase_tooltip (phase) {
            const lines = [`<strong>${phase.abbreviation}: ${this.phase_start_date(phase).format("MMM DD, YYYY")} - ${this.$moment(phase.computed_ends_at_as_string).format("MMM DD, YYYY")}</strong>`]
            orderBy(this.phase_milestones(phase), "ends_at_as_string", "asc").forEach(milestone => {
                lines.push(this.milestone_tooltip(milestone))
            })
            return lines.join("<br/>")
        },
        milestone_tooltip (milestone) {
            return `${milestone.description}: Due ${this.$moment(milestone.ends_at_as_string).format("MMM DD, YYYY")}`
        },
        save_favorite (project, favorite) {
            this.save_field_for_record_id("project", project.id, favorite, "favorite")
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_phase_records () {
            return this.entity_records("phase")
        },
        raw_task_records () {
            return this.entity_records("task")
        },
        cell_width () {
            if(!this.mounted) return 0 // make it responsive
            const container_width = this.$el.clientWidth - this.row_header_width
            return Math.round(container_width / this.state.scope)
            // return Math.max(52, Math.round(container_width / this.state.scope))
        },
        fields () {
            return [
                "sortable_number",
                "computed_sortable_current_phase",
                "number",
                "number_suffix",
                "name",
                "nickname",
                "favorite",
                "hex_color",
                "significance",
                "computed_fee",
                "computed_spent",
                "pic_id",
                "pm_id",
                "ns::phase;id,project_id,abbreviation,title,computed_starts_at_as_string,computed_ends_at_as_string,hex_color",
                "ns::task;id,phase_id,project_id,starts_at_as_string,ends_at_as_string,description,milestone_title"
            ]
        },
        min_date () {
            const phase = orderBy(this.raw_phase_records, "computed_starts_at_as_string", "asc")[0]
            const this_week = this.$moment().startOf("isoWeek")
            if(!phase) return this_week
            return this.$moment.max(this.$moment(phase.computed_starts_at_as_string), this_week).startOf("isoWeek")
        },
        max_date () {
            const phase = orderBy(this.raw_phase_records, "computed_ends_at_as_string", "desc")[0]
            const next_week = this.$moment().startOf("isoWeek").add(1, "week")
            if(!phase) return next_week
            return this.$moment(phase.computed_ends_at_as_string).startOf("isoWeek")
        },
        weeks () {
            const weeks = []
            const date = this.$moment(this.min_date)
            for(let loop = 0; loop < this.state.scope; loop++) {
                weeks.push(this.$moment(date))
                date.add(1, "week")
            }
            return weeks
        },
        sorted_projects () {
            return orderBy(this.rows, this.state.sort_by, this.state.sort_dir)
        }
    },
    props: {
        userId: {
            type: Number,
            default: 0
        },
        currentStatusFilter: {
            type: String,
            validator: prop => !prop || prop.match(/^(starred|Active|On Hold|Completed|Dead)$/)
        },
        currentSort: {
            type: String,
            validator: prop => !prop || prop.match(/^(sortable_number|computed_sortable_current_phase)$/)
        },
        currentSortDir: {
            type: String,
            validator: prop => !prop || prop.match(/^(asc|desc)$/i)
        },
        dateRange: {
            type: Number,
            validator: prop => [6, 13, 26, 52].indexOf(prop) >= 0
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            mounted: false,
            row_header_width: 200, // KEEP IN SYNC with css' @row-header-width

            entity: "project",
            relation_ids: ["phase", "task"],

            default_state: {
                per_page: 0, // 25,
                page: 1,
                sort_by: "sortable_number",
                sort_dir: "desc",
                filter_on: "shelf_life",
                filter: "starred",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "linear-calendar",
                context_id: -1,
                activated_at: 1,
                scope: 6 // in weeks
            }
        }
    }
}
</script>

<style lang="less">
@import "@/assets/less/variables";

.lam-linear-calendar-container {
    @row-header-width: 200px; // KEEP in sync with data.row_header_width
    @padding: 0.7em;
    position: relative;

    .lam-linear-calendar {
        height: 70vh;
        border: 1px solid @global-border;
        overflow-y: auto;
        overflow-x: hidden;
        overscroll-behavior: contain;
        background-color: @base-body-background;

        &.short {
            height: 33vh;
        }

        & > .chart {
            position: sticky;
            top: 0;
            display: grid;
            z-index: 100;
        }
    }
    .chart-row {
        display: grid;
        grid-template-columns: @row-header-width 1fr;

        .chart-row-item {
            border-right: 1px solid @global-border;
            // padding: 0.3em 0;
            position: sticky;
            left: 0;
            cursor: pointer;
            z-index: 10;

            & > div {
                padding: @padding / 2;

                & > div:first-child {
                    overflow-x: hidden;
                    overscroll-behavior: contain;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .uk-button-link:hover, .uk-button-link:focus, .uk-button-link:active, .uk-button-link.uk-active {
                color: white;
            }

            &.uk-text-contrast {
                .uk-button-link:hover, .uk-button-link:focus, .uk-button-link:active, .uk-button-link.uk-active {
                    color: #040404;
                }
            }

            &.small {
                font-size: 0.8em;
                padding: 0.3em 0;

                & > div {
                    padding: 0.2em @padding;
                }
            }
            &.large {
                & > div {
                    padding: (3 * @padding) @padding;
                }
            }
        }
        .chart-row-bars {
            display: grid;
            list-style: none;
            padding: 0.25em 0;
            margin: 0;
            // grid-template-columns: repeat(12, @cell-width);
            // grid-gap: @padding;

            & > li {
                position: relative;
                text-align: left;
                padding: 0;
                margin-bottom: 1px;
                margin-right: 2px;
                overflow-x: hidden;
                overscroll-behavior: contain;
                cursor: pointer;

                & > .phase {
                    position: relative;
                    padding: @padding;
                    // height: calc(100% - (2 * @padding) - 2px);
                    // height: 100%; //calc(100% - (2 * @padding) - 2px);
                    background-color: #696969;
                    // border: 1px solid #d8d8d8;

                    & > span {
                        position: absolute;
                        left: @padding;
                        top: 50%;
                        transform: translate(0, -50%);
                        white-space: nowrap;
                        font-weight: bold;
                        z-index: 5;

                        & > .chip {
                            position: relative;
                            display: none;
                            width: 1em;
                            height: 1em;
                            top: 0.15em;
                            margin-right: 0.5em;
                            border-radius: 50%;
                        }
                    }
                    & > .milestone {
                        position: absolute;
                        top: 0;
                        height: 100%;
                        background-color: @global-lam-orange;
                        color: white;
                        z-index: 0;

                        &.task {
                            background-color: @global-lam-sunset;
                        }
                    }
                }
            }

            &.small {
                & > div {
                    padding: 0.2em @padding;
                }
            }
            &.large {
                & > div {
                    padding: (3 * @padding) @padding;
                    height: calc(100% - (6 * @padding));
                }
            }
        }

        &.chart-period {
            background-color: @global-lam-daylight;
            border-bottom: 1px solid @global-border;
            // grid-template-columns: @row-header-width repeat(12, @cell-width);

            & > .chart-row-item {
                border-bottom: 0;
            }
            & > span {
                text-align: center;
                align-self: center;
                padding: @padding 0;
            }
        }
        &.chart-lines {
            position: absolute;
            height: 100%;
            width: 100%;
            background-color: transparent;
            // grid-template-columns: @row-header-width repeat(12, @cell-width);
            pointer-events: none;

            & > span {
                display: block;
                border-right: 1px solid @global-border;
            }
        }
    }
}

.uk-tooltip {
    max-width: 90%;
    white-space: nowrap;
}
</style>
